// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Interface } from "./interface";

export class IdlSummary implements flatbuffers.IUnpackableObject<IdlSummaryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlSummary {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlSummary(bb: flatbuffers.ByteBuffer, obj?: IdlSummary): IdlSummary {
    return (obj || new IdlSummary()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlSummary(bb: flatbuffers.ByteBuffer, obj?: IdlSummary): IdlSummary {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlSummary()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  iface(): Interface | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  schemaVersion(): string | null;
  schemaVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  schemaVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  entries(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  expandedKeys(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  mapped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  unmapped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  profileOnly(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  overrides(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  events(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  eventsUnmapped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  eventsReworded(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  eventsRetargeted(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  errors(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  warnings(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  controls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  controlsUnmapped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startIdlSummary(builder: flatbuffers.Builder) {
    builder.startObject(16);
  }

  static addIface(builder: flatbuffers.Builder, iface: Interface) {
    builder.addFieldInt8(0, iface, null);
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, schemaVersionOffset, 0);
  }

  static addEntries(builder: flatbuffers.Builder, entries: number) {
    builder.addFieldInt32(2, entries, 0);
  }

  static addExpandedKeys(builder: flatbuffers.Builder, expandedKeys: number) {
    builder.addFieldInt32(3, expandedKeys, 0);
  }

  static addMapped(builder: flatbuffers.Builder, mapped: number) {
    builder.addFieldInt32(4, mapped, 0);
  }

  static addUnmapped(builder: flatbuffers.Builder, unmapped: number) {
    builder.addFieldInt32(5, unmapped, 0);
  }

  static addProfileOnly(builder: flatbuffers.Builder, profileOnly: number) {
    builder.addFieldInt32(6, profileOnly, 0);
  }

  static addOverrides(builder: flatbuffers.Builder, overrides: number) {
    builder.addFieldInt32(7, overrides, 0);
  }

  static addEvents(builder: flatbuffers.Builder, events: number) {
    builder.addFieldInt32(8, events, 0);
  }

  static addEventsUnmapped(builder: flatbuffers.Builder, eventsUnmapped: number) {
    builder.addFieldInt32(9, eventsUnmapped, 0);
  }

  static addEventsReworded(builder: flatbuffers.Builder, eventsReworded: number) {
    builder.addFieldInt32(10, eventsReworded, 0);
  }

  static addEventsRetargeted(builder: flatbuffers.Builder, eventsRetargeted: number) {
    builder.addFieldInt32(11, eventsRetargeted, 0);
  }

  static addErrors(builder: flatbuffers.Builder, errors: number) {
    builder.addFieldInt32(12, errors, 0);
  }

  static addWarnings(builder: flatbuffers.Builder, warnings: number) {
    builder.addFieldInt32(13, warnings, 0);
  }

  static addControls(builder: flatbuffers.Builder, controls: number) {
    builder.addFieldInt32(14, controls, 0);
  }

  static addControlsUnmapped(builder: flatbuffers.Builder, controlsUnmapped: number) {
    builder.addFieldInt32(15, controlsUnmapped, 0);
  }

  static endIdlSummary(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIdlSummary(
    builder: flatbuffers.Builder,
    iface: Interface | null,
    schemaVersionOffset: flatbuffers.Offset,
    entries: number,
    expandedKeys: number,
    mapped: number,
    unmapped: number,
    profileOnly: number,
    overrides: number,
    events: number,
    eventsUnmapped: number,
    eventsReworded: number,
    eventsRetargeted: number,
    errors: number,
    warnings: number,
    controls: number,
    controlsUnmapped: number,
  ): flatbuffers.Offset {
    IdlSummary.startIdlSummary(builder);
    if (iface !== null) IdlSummary.addIface(builder, iface);
    IdlSummary.addSchemaVersion(builder, schemaVersionOffset);
    IdlSummary.addEntries(builder, entries);
    IdlSummary.addExpandedKeys(builder, expandedKeys);
    IdlSummary.addMapped(builder, mapped);
    IdlSummary.addUnmapped(builder, unmapped);
    IdlSummary.addProfileOnly(builder, profileOnly);
    IdlSummary.addOverrides(builder, overrides);
    IdlSummary.addEvents(builder, events);
    IdlSummary.addEventsUnmapped(builder, eventsUnmapped);
    IdlSummary.addEventsReworded(builder, eventsReworded);
    IdlSummary.addEventsRetargeted(builder, eventsRetargeted);
    IdlSummary.addErrors(builder, errors);
    IdlSummary.addWarnings(builder, warnings);
    IdlSummary.addControls(builder, controls);
    IdlSummary.addControlsUnmapped(builder, controlsUnmapped);
    return IdlSummary.endIdlSummary(builder);
  }

  unpack(): IdlSummaryT {
    return new IdlSummaryT(
      this.iface(),
      this.schemaVersion(),
      this.entries(),
      this.expandedKeys(),
      this.mapped(),
      this.unmapped(),
      this.profileOnly(),
      this.overrides(),
      this.events(),
      this.eventsUnmapped(),
      this.eventsReworded(),
      this.eventsRetargeted(),
      this.errors(),
      this.warnings(),
      this.controls(),
      this.controlsUnmapped(),
    );
  }

  unpackTo(_o: IdlSummaryT): void {
    _o.iface = this.iface();
    _o.schemaVersion = this.schemaVersion();
    _o.entries = this.entries();
    _o.expandedKeys = this.expandedKeys();
    _o.mapped = this.mapped();
    _o.unmapped = this.unmapped();
    _o.profileOnly = this.profileOnly();
    _o.overrides = this.overrides();
    _o.events = this.events();
    _o.eventsUnmapped = this.eventsUnmapped();
    _o.eventsReworded = this.eventsReworded();
    _o.eventsRetargeted = this.eventsRetargeted();
    _o.errors = this.errors();
    _o.warnings = this.warnings();
    _o.controls = this.controls();
    _o.controlsUnmapped = this.controlsUnmapped();
  }

  unpackFields(...fields: string[]): IdlSummaryT {
    const t = new IdlSummaryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("iface")) {
      t.iface = this.iface();
    }
    if (fieldSet.has("schema_version")) {
      t.schemaVersion = this.schemaVersion();
    }
    if (fieldSet.has("entries")) {
      t.entries = this.entries();
    }
    if (fieldSet.has("expanded_keys")) {
      t.expandedKeys = this.expandedKeys();
    }
    if (fieldSet.has("mapped")) {
      t.mapped = this.mapped();
    }
    if (fieldSet.has("unmapped")) {
      t.unmapped = this.unmapped();
    }
    if (fieldSet.has("profile_only")) {
      t.profileOnly = this.profileOnly();
    }
    if (fieldSet.has("overrides")) {
      t.overrides = this.overrides();
    }
    if (fieldSet.has("events")) {
      t.events = this.events();
    }
    if (fieldSet.has("events_unmapped")) {
      t.eventsUnmapped = this.eventsUnmapped();
    }
    if (fieldSet.has("events_reworded")) {
      t.eventsReworded = this.eventsReworded();
    }
    if (fieldSet.has("events_retargeted")) {
      t.eventsRetargeted = this.eventsRetargeted();
    }
    if (fieldSet.has("errors")) {
      t.errors = this.errors();
    }
    if (fieldSet.has("warnings")) {
      t.warnings = this.warnings();
    }
    if (fieldSet.has("controls")) {
      t.controls = this.controls();
    }
    if (fieldSet.has("controls_unmapped")) {
      t.controlsUnmapped = this.controlsUnmapped();
    }
    return t;
  }
}

export class IdlSummaryT implements flatbuffers.IGeneratedObject {
  constructor(
    public iface: Interface | null = null,
    public schemaVersion: string | Uint8Array | null = null,
    public entries: number = 0,
    public expandedKeys: number = 0,
    public mapped: number = 0,
    public unmapped: number = 0,
    public profileOnly: number = 0,
    public overrides: number = 0,
    public events: number = 0,
    public eventsUnmapped: number = 0,
    public eventsReworded: number = 0,
    public eventsRetargeted: number = 0,
    public errors: number = 0,
    public warnings: number = 0,
    public controls: number = 0,
    public controlsUnmapped: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const schemaVersion =
      this.schemaVersion !== null ? builder.createString(this.schemaVersion!) : 0;

    return IdlSummary.createIdlSummary(
      builder,
      this.iface,
      schemaVersion,
      this.entries,
      this.expandedKeys,
      this.mapped,
      this.unmapped,
      this.profileOnly,
      this.overrides,
      this.events,
      this.eventsUnmapped,
      this.eventsReworded,
      this.eventsRetargeted,
      this.errors,
      this.warnings,
      this.controls,
      this.controlsUnmapped,
    );
  }

  clone(): IdlSummaryT {
    const obj = new IdlSummaryT();
    obj.iface = this.iface;
    obj.schemaVersion = this.schemaVersion;
    obj.entries = this.entries;
    obj.expandedKeys = this.expandedKeys;
    obj.mapped = this.mapped;
    obj.unmapped = this.unmapped;
    obj.profileOnly = this.profileOnly;
    obj.overrides = this.overrides;
    obj.events = this.events;
    obj.eventsUnmapped = this.eventsUnmapped;
    obj.eventsReworded = this.eventsReworded;
    obj.eventsRetargeted = this.eventsRetargeted;
    obj.errors = this.errors;
    obj.warnings = this.warnings;
    obj.controls = this.controls;
    obj.controlsUnmapped = this.controlsUnmapped;
    return obj;
  }

  equals(other: IdlSummaryT): boolean {
    if (this.iface !== other.iface) return false;
    if (this.schemaVersion !== other.schemaVersion) return false;
    if (this.entries !== other.entries) return false;
    if (this.expandedKeys !== other.expandedKeys) return false;
    if (this.mapped !== other.mapped) return false;
    if (this.unmapped !== other.unmapped) return false;
    if (this.profileOnly !== other.profileOnly) return false;
    if (this.overrides !== other.overrides) return false;
    if (this.events !== other.events) return false;
    if (this.eventsUnmapped !== other.eventsUnmapped) return false;
    if (this.eventsReworded !== other.eventsReworded) return false;
    if (this.eventsRetargeted !== other.eventsRetargeted) return false;
    if (this.errors !== other.errors) return false;
    if (this.warnings !== other.warnings) return false;
    if (this.controls !== other.controls) return false;
    if (this.controlsUnmapped !== other.controlsUnmapped) return false;
    return true;
  }
}

export function verifyIdlSummary(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 4);
  } finally {
    verifier.popDepth();
  }
}
